// Public office hours — shared across every surface that displays contact
// or branch information (contact page, home contact block, careers branch
// details, customer portal branch card, etc.).

export const OFFICE_HOURS_LINES = [
    "Monday – Saturday: 11:00 AM – 5:00 PM",
    "Closed: Every Sunday",
    "Closed: 2nd & 4th Saturday",
];

// Single-line summary useful in tight layouts.
export const OFFICE_HOURS_SHORT = "Mon – Sat, 11 AM – 5 PM (Closed Sun & 2nd/4th Sat)";

/**
 * Renders the office-hours block. Callers style the container; this component
 * simply lists each line so callers don't need to keep the strings in sync.
 */
export function OfficeHours({ className = "", lineClassName = "" }) {
    return (
        <div className={className} data-testid="office-hours">
            {OFFICE_HOURS_LINES.map((line) => (
                <div key={line} className={lineClassName}>
                    {line}
                </div>
            ))}
        </div>
    );
}
